const middleware = {}

middleware['accountLock'] = require('../middleware/accountLock.ts')
middleware['accountLock'] = middleware['accountLock'].default || middleware['accountLock']

middleware['role'] = require('../middleware/role.js')
middleware['role'] = middleware['role'].default || middleware['role']

export default middleware
